import { render, staticRenderFns } from "./CollapseSection.vue?vue&type=template&id=f5171416&scoped=true"
import script from "./CollapseSection.vue?vue&type=script&lang=js"
export * from "./CollapseSection.vue?vue&type=script&lang=js"
import style0 from "./CollapseSection.vue?vue&type=style&index=0&id=f5171416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5171416",
  null
  
)

export default component.exports